import React from 'react';
import {Text, Spacer, Dropdown, Stack, FormControl, Tag} from '@lego/klik-ui';


interface IOptionsType {
  value: string;
  text: string;
  group?: string;
}


export const ControlledDropdown: React.FC = () => {
  const defaultSelection = ['DK', 'FI'];

  const options: IOptionsType[] = [
    { value: 'DK', text: 'Denmark' },
    { value: 'NO', text: 'Norway' },
    { value: 'SE', text: 'Sweden' },
    { value: 'IS', text: 'Iceland' },
    { value: 'FI', text: 'Finland' },
  ];

  const [selection, setSelection] = React.useState<string[]>(defaultSelection);

  const handleOnChange = React.useCallback(
    (value: string[]) => {
      setSelection(value);
    },
    [selection]
  );

  const removeKey = React.useCallback(
    (key: string) => {
      setSelection(selection.filter((itm) => itm !== key));
    },
    [selection]
  );

  return (
    <Stack spacing={4}>
      
      <Stack direction="row">
        {selection.map((sel) => {
          const opt: IOptionsType = options.filter((itm) => itm.value === sel)[0];

          return (
            <Tag key={opt.value}>
              <Tag.Label>{opt.text}</Tag.Label>
              <Tag.CloseButton onClick={() => void removeKey(opt.value)} />
            </Tag>
          );
        })}
      </Stack>
      <Spacer h="2rem" />
      <FormControl>
        <FormControl.Label>Choose some countries</FormControl.Label>
        <Dropdown
          isMultiple={true}
          onChange={handleOnChange}
          shouldDisplaySelectionLabels={true}
          value={selection}
          selectionIndicator={'check'}
        >
          {options.map((opt) => (
            <Dropdown.Option key={opt.value} value={opt.value}>
              {opt.text}
            </Dropdown.Option>
          ))}
        </Dropdown>
      </FormControl>
    </Stack>
  );
};
